module.exports = __webpack_public_path__ + "img/more.037da16d.svg";